
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/trino",
      function () {
        return require("private-next-pages/sources/trino.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/trino"])
      });
    }
  